import { IUpdateAppointmentPayload } from "@modules/eirCustomersFacade/interfaces/payloads/IUpdateAppointmentPayload";
import { getKeyEnumFromValue } from "@utils/enumUtils";
import { ETimeSlot } from "@modules/eirCustomersFacade/interfaces/models/IAvailableAppointmentDate";

export const mapUpdateAppointmentPayload = (dateValue: string, timeSlot: ETimeSlot): IUpdateAppointmentPayload => ({
    scheduledDate: dateValue,
    timeSlot: getKeyEnumFromValue(ETimeSlot, timeSlot) ?? "",
});
